<template>
	<div>
		<CHead :oHead="Head"></CHead>
		<div class="row justify-content-center">
			<div class="col-md-6 col-lg-5">
				<Clist :regresar="true" :Nombre="NameList" :Filtro="Filtro" :isModal="EsModal" :pShowBtnAdd="false" :ShowHead="false" :pConfigLoad="ConfigLoad">
					<template slot="header">
						<tr>
							<th>Concepto</th>
							<th>Monto</th>
							<th>Acciones</th>
						</tr>
					</template>
					<template slot="body">
						<tr v-for="(item,index) in ListaSueldos" :key="index">
							<td>{{EvalConcepto(item.Tipo)}}</td>
							<td>${{Number(item.Cantidad ).toLocaleString('es-MX')}}</td>
							<td>
								<Cbtnaccion :PBtndelete="false" :isModal="EsModal" :Id="item.IdSueldo" :IrA="FormName"></Cbtnaccion>
							</td>
						</tr>
					</template>
				</Clist>
				<Modal :size="size" :Nombre="NameForm" :poBtnSave="oBtnSave">
                    <template slot="Form">
                    	<Form :NameList="NameForm"  :poBtnSave="oBtnSave"></Form>
                    </template>
                </Modal>
			</div>
		</div>
	</div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/catalogos/sueldos/Form.vue';
import CHead from "@/components/CHead.vue";
export default {
	name:'listsueldos',
	components:{
		Modal,
        Clist,
        Cbtnaccion,
        Form,
        CHead,
	},
	data() {
		return {
			FormName:'sueldos',
			EsModal:true,
			CloseModal:true,
			NameList:"Sueldos",
            NameForm:"Sueldos",
            urlApi:"sueldo/get",
            ListaSueldos:[],
            ListaHeader:[],
			Filtro:{
				Nombre:'',
            	Placeholder:'Nombre..',
            	TotalItem:0,
            	Pagina:1,
            	Show:false
			},
			oBtnSave:{
				isModal:true,
                disableBtn:false,
                toast:0,
			},
			Head: {
				ShowHead: true,
				Title: "Sueldos",
				BtnNewShow: false,
				BtnNewName: "Nuevo",
				isreturn: true,
				isModal: true,
				isEmit: true,
				Url: "",
				ObjReturn: "",
				NameReturn: "Regresar",
				isCuentas: false,
				verFiltroCuentas: false
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			}
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader = true;
			await this.$http.get('sueldo/get').then((res) => {
				this.ListaSueldos =res.data.data.sueldos;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			})
		},
		EvalConcepto(Concepto){
			let Cadena='';
			switch (Concepto) {
				case '1':
					Cadena="Mano de Obra";
					break;
				case '2':
					Cadena="Burden";
					break;			
				default:
					break;
			};
			return Cadena;
		}
	},
	created() {
		this.bus.$off('List');
		this.bus.$on('List',()=>
        {
            this.Lista();
        });
		this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>
        {
            this.$router.push({name:'submenuadmon'});
        });
		this.Lista();
	},
}
</script>

<style>

</style>
